const enMessages = require("../locales/en_US.json");
const enLang = {
  messages: {
    ...enMessages,
  },
  commingSoon: {
    header: "2022 Eastspring Wealth Privilege Program has ended since Dec 31, 2022",
    message: "Stay tuned. 2023 Privilege Program is coming soon."
  },
  locale: "en-US",
};
export default enLang;
